export const DETAIL_PAGE_REQUEST = "detailPageReducer/DETAIL_PAGE_REQUEST";
export const DETAIL_PAGE_SUCCESS = "detailPageReducer/DETAIL_PAGE_SUCCESS";
export const DETAIL_PAGE_FAILED = "detailPageReducer/DETAIL_PAGE_FAILED";
export const CHANGE_LOGO_DETAIL_PAGE =
  "detailPageReducer/CHANGE_LOGO_DETAIL_PAGE";
export const CHANGE_DATE_DETAIL_PAGE =
  "detailPageReducer/CHANGE_DATE_DETAIL_PAGE";
